export default __webpack_public_path__ + "static/media/step_B_UA.2f5c8ba9.png";